/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Script } from 'gatsby';
import { testAttributes, defaultAttributes } from './Constants';
import { trustPilotContainer } from './TrustPilotWidget.module.scss';

function TrustPilotWidget() 
{
    const onLoadHandler = () =>
    {
        if (window?.Trustpilot)
        {
            window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'), true);
        }
    }

    return (
        <div className={trustPilotContainer}>
            <Script
                src={defaultAttributes.URL}
                strategy="post-hydrate"
                data-test-id={testAttributes.TRUSTPILOT_SCRIPT}
                onLoad={onLoadHandler}
            />
            <trust-pilot-component _ngcontent-jqo-c100="">
                <div
                    data-testid={testAttributes.TRUSTPILOT_CONTAINER}
                    className="trustpilot-widget"
                    data-locale="en-US"
                    data-template-id={defaultAttributes.TEMPLATE}
                    data-businessunit-id={defaultAttributes.BUSINESS}
                    data-style-height="140px"
                    data-style-width="100%"
                    data-theme="light"
                    data-review-languages="en"
                    data-tags="SelectedReview"
                >
                    <a
                        href="https://www.trustpilot.com/review/www.quickenloans.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Trustpilot
                    </a>
                </div>
            </trust-pilot-component>
        </div>
    );
}

export default TrustPilotWidget;
